import { useApplication } from "@/context/app";
import { createSignal, For, onMount } from "solid-js";
import { useParams } from "@solidjs/router";
import { SelectInput } from "../../components/ui/form/SelectInput";
import { ComboBoxInput } from "../../components/ui/form/ComboBoxInput";
import { TextInput } from "../../components/ui/form/TextInput";
import { TextAreaInput } from "../../components/ui/form/TextAreaInput";
import { NumberInput } from "../../components/ui/form/NumberInput";
import {
  Card,
  CardContent,
  CardHeader,
  CardDescription,
  CardTitle
} from "@/components/shadcn/card";
import { LoadingButton } from "@/components/ui/Button";
import ImageUploader from "@/components/ui/ImageUploader";;
import useTherapyForm from "../../services/useTherapySessionForm";
import { FileInput } from "../../components/ui/form/FileInput";

export default function ManagerForm() {

  const { setBreadcrumb } = useApplication();

  const {
    form,
    handleInput,
    handleChange,
    handleSave,
    fetchInfo,
    loading,
    therapy,
    setTherapy
  } = useTherapyForm();

  const params = useParams();
  if (params.therapy !== undefined && params.therapy !== null) {
    setTherapy(params.therapy);
  } else {
    navigate("/therapies");
  }

  if (params.key !== undefined && params.key !== null) {
    fetchInfo(params.key);
  }

  onMount(async () => {
    setBreadcrumb([
      {
        name: 'Home',
        link: '/home'
      },
      {
        name: 'Therapy',
        link: '/therapies'
      },
      {
        name: 'Sessions',
        link: '/therapy/' + therapy() + '/sessions'
      },
      {
        name: params.key !== undefined && params.key !== null ? 'Edit' : 'Create',
        current: true
      }
    ]);
  });

  return (
    <div className="main-card">
      <form autocomplete="off">
        <div class="grid grid-cols-12 gap-2">
          <Card class="lg:col-span-12 col-span-12">
            <CardHeader>
              <CardTitle>Basic Information</CardTitle>
            </CardHeader>
            <CardContent>
              <div class="grid grid-cols-8 gap-2">
                <div class="form-group col-span-8">
                  <TextInput
                    label="Title"
                    name="title"
                    form={form}
                    input={handleChange}
                  />
                </div>
                <div class="form-group col-span-8">
                  <TextAreaInput
                    label="Objectives"
                    name="objectives"
                    form={form}
                    input={handleChange}
                  />
                </div>
                <div class="form-group col-span-8">
                  <FileInput
                    label="Video"
                    name="video"
                    form={form}
                    input={handleChange}
                  />
                </div>
                <div class="form-group col-span-4">
                  <TextAreaInput
                    label="Instructions"
                    name="instructions"
                    form={form}
                    input={handleChange}
                  />
                </div>
                <div class="form-group col-span-4">
                  <TextAreaInput
                    label="Instructions Urdu"
                    name="instructionsUrdu"
                    form={form}
                    input={handleChange}
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
        <div class="text-end mt-3">
          <LoadingButton loading={loading()} onClick={handleSave}>Save</LoadingButton>
        </div>
      </form>
    </div>
  );
}
